import { BaseLegacy } from './base';

export type GenericCustomFieldValue = {
	Id?: number;
	GenericCustomFieldId: number;
	ObjectId: number;
	Value: string;
};

export type GenericCustomFieldTranslation = {
	Id: number;
	CultureId: number;
	Value: string;
};

export interface GenericCustomFieldOption {
	Id: number;
	Name: string;
	Order: number;
}

export interface GenericCustomField extends BaseLegacy {
	DataType: GenericCustomFieldDataType;
	Order: number;
	IsMandatory: boolean;
	IsReadOnly: boolean;
	SystemName: string;
	RegEx?: string;
	Placeholder?: string;
	ObjectType: GenericCustomFieldObjectType;
	Options?: GenericCustomFieldOption[];
	Translations?: GenericCustomFieldTranslation[];
	Value: GenericCustomFieldValue | null;
}

export enum GenericCustomFieldDataType {
	Textbox = 1,
	Password = 2,
	Email = 3,
	Textarea = 4,
	Checkbox = 5,
	Checkboxlist = 6,
	Radiobutton = 7,
	Select = 8,
	TextboxNumber = 9,
	MediaBankFile = 10,
	Date = 11,
}

export enum GenericCustomFieldObjectType {
	User = 1,
	Area = 2,
	Unit = 3,
	UnitType = 4,
	Event = 5,
}
